/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { activeCompanyId as selectedActiveCompanyId } from '@/redux/selectors/userSelectors.js';
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';

export const sidebarOrganization = createSelector([(state, sidebarType = 'home') => state?.pieve?.sidebarOrganizationByType?.[sidebarType] || null, selectedActiveCompanyId], (organization, activeCompanyId) => {
  if (!organization || !activeCompanyId || organization.scopeCompanyId !== activeCompanyId) {
    return null;
  }

  return organization;
});

export const sidebarOrganizationGroups = createSelector([sidebarOrganization], (organization) => organization?.groups || EMPTY_ARRAY);
export const sidebarOrganizationFolders = createSelector([sidebarOrganization], (organization) => organization?.folders || EMPTY_ARRAY);
export const sidebarOrganizationPlacements = createSelector([sidebarOrganization], (organization) => organization?.placements || EMPTY_ARRAY);
export const sidebarOrganizationLoaded = createSelector([sidebarOrganization], (organization) => organization?.loaded === true);
export const sidebarOrganizationPending = (state, sidebarType = 'home') => (state?.pieve?.sidebarOrganizationPendingMutations || EMPTY_ARRAY).some((pendingMutation) => pendingMutation.sidebarType === sidebarType);
